import { render, staticRenderFns } from "./CreateCustomerAccountLimitRequestPopUp.vue?vue&type=template&id=5c3368c8&scoped=true&"
import script from "./CreateCustomerAccountLimitRequestPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerAccountLimitRequestPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerAccountLimitRequestPopUp.vue?vue&type=style&index=0&id=5c3368c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3368c8",
  null
  
)

export default component.exports